/**
 * Per-tab note of which emailed link this tab is working through. NOT a
 * permission — the session itself is the refresh cookie, and the backend binds
 * it to one link.
 *
 * Kept so two things work without the `?token=` in the URL: a lapsed session
 * can re-run the code challenge in place (the reauth route only returns the
 * pathname), and opening a DIFFERENT link can be told apart from reloading this
 * one — a cookie left over from another job must not answer for the new link.
 *
 * sessionStorage: survives reloads, dies with the tab.
 */

const JOB_SESSION_KEY = 'codezo_vetter_job_link';

export const JOB_PATH = '/job';

export function getJobLinkToken(): string | null {
	try {
		return sessionStorage.getItem(JOB_SESSION_KEY);
	} catch {
		return null;
	}
}

export function setJobLinkToken(linkToken: string): void {
	try {
		sessionStorage.setItem(JOB_SESSION_KEY, linkToken);
	} catch {
		// Private-mode/quota failures are non-fatal — a reload just asks for the code again.
	}
}

export function clearJobLinkToken(): void {
	try {
		sessionStorage.removeItem(JOB_SESSION_KEY);
	} catch {
		// ignore
	}
}
